import React, { useMemo, useContext, useCallback } from 'react'
import { Heading1 } from '@usap/widgets'
import {
  Box, Text, Button, useResponsiveWrapperContext,
} from '@usap/uicomponents'

import { LocalContext } from '../../../../helpers/useLocalContext'
import useIsWmoEnabled from '../../../../hooks/useWmoEnabled'
import TitleWmo from './TitleWmo'

const Title = () => {
  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { history } = localContext

  const style = useMemo(
    () => ({
      padding1: { bottom: 'medium' },
      style1: { fontSize: isDesktop ? 28 : 20 },
      border1: { color: 'light-3', size: 'xsmall' },
      padding2: { vertical: '8px', horizontal: '16px' },
    }),
    [isDesktop],
  )

  const goToSaveCart = useCallback(() => {
    history.push('/cart/savequote')
  }, [history])

  // helps GTM identify the click on parent button
  const pointerEventsNone = useMemo(() => ({
    pointerEvents: 'none',
  }), [])

  const isWmoEnabled = useIsWmoEnabled()
  if (isWmoEnabled) {
    return <TitleWmo goToSaveCart={goToSaveCart} />
  }

  return (
    <Box
      direction="row"
      pad={style.padding1}
      justify="between"
      align="center"
    >
      <Heading1
        size={isDesktop ? 'medium' : 'small'}
        title="Shopping Cart"
        style={style.style1}
      />

      <Box
        border={style.border1}
        round="xsmall"
        justify="center"
        pad={style.padding2}
        background="white"
      >
        <Button
          plain
          color="white"
          onClick={goToSaveCart}
          data-testid="save-cart-on-cart"
          label={(
            <Text color="dark-2" size="small" style={pointerEventsNone}>
              Save Cart
            </Text>
          )}
        />
      </Box>
    </Box>
  )
}

export default Title
